










import { defineComponent, PropType } from '@vue/composition-api'
import Store from '@/classes/Store'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
  },
})
